import { useTimeRange } from 'hooks';
import { DateTime } from 'luxon';
import { utcToday } from 'utils/dateUtils';
import TimeRangeReportDialog, { ITimeRangeReportDialogProps } from '../TimeRangeReportDialog/TimeRangeReportDialog';

export type ManagedTimeRangeReportDialogProps = Omit<
  ITimeRangeReportDialogProps,
  'back' | 'forward' | 'backEnabled' | 'forwardEnabled'
> & {
  minimumTime?: DateTime | null;
  maximumTime?: DateTime;
  zone?: 'system' | 'utc';
};

const ManagedTimeRangeReportDialog = ({
  timeRange: selectedTimeRange,
  timeRangeType,
  minimumTime = null,
  maximumTime = utcToday().startTime,
  zone = 'utc',
  ...other
}: ManagedTimeRangeReportDialogProps) => {
  return (
    <TimeRangeReportDialog
      {...useTimeRange(timeRangeType, selectedTimeRange, minimumTime, maximumTime, zone)}
      {...other}
    />
  );
};

export default ManagedTimeRangeReportDialog;
